var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.889,
    height: 16,
    viewBox: "0 0 25.889 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "american_express_logo",
    "data-name": "american express logo",
    transform: "translate(-707 -613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33342",
    "data-name": "Path 33342",
    d: "M716.444,740.711h7v12.578h-7Z",
    transform: "translate(0 -126)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33343",
    "data-name": "Path 33343",
    d: "M716.889,747a8.022,8.022,0,0,1,3.044-6.289,8,8,0,1,0,0,12.578A7.989,7.989,0,0,1,716.889,747Z",
    transform: "translate(0 -126)",
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33344",
    "data-name": "Path 33344",
    d: "M732.889,747a7.991,7.991,0,0,1-12.933,6.289,8.017,8.017,0,0,0,0-12.578A7.991,7.991,0,0,1,732.889,747Z",
    transform: "translate(0 -126)",
    fill: "#f79e1b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMastercard);
export default __webpack_public_path__ + "static/media/paymentMastercard.f9234e60593d6e41b52251efc87cc9ea.svg";
export { ForwardRef as ReactComponent };